import { render, staticRenderFns } from "./stateWatingModel8.vue?vue&type=template&id=05dd48f7&scoped=true"
import script from "./stateWatingModel8.vue?vue&type=script&lang=js"
export * from "./stateWatingModel8.vue?vue&type=script&lang=js"
import style1 from "./stateWatingModel8.vue?vue&type=style&index=1&id=05dd48f7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05dd48f7",
  null
  
)

export default component.exports